import React from 'react'
import { ToggleButtonGroup, ToggleButton } from '@mui/material'

const Map = ({ mapRef }) => {
  const [mapType, setMapType] = React.useState('road')
  
    const updateMapType = (type) => {
      const source = mapRef.current.map.getLayers().item(0).getSource()

      switch(type) {
        case "road":
          source.setUrl('https://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}')
          break
        case "satellite":
          source.setUrl('https://mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}')
          break
      }
      
      source.refresh()
    }

  return (
    <div style={{ width: "100%", height: "100%", position: "relative" }}>
      <div style={{ height: "100%", width: "100%" }} id="map" />
{/* 
      <div style={{ position: "absolute", top: 16, right: 16 }}>
        <ToggleButtonGroup size="small" style={{ backgroundColor: "white" }} value={mapType} exclusive onChange={(_, value) => { setMapType(value); updateMapType(value);}}>
          <ToggleButton value="road" aria-label="left aligned">
            <div style={{ width: "80px" }}>Road</div>
          </ToggleButton>
          <ToggleButton value="satellite" aria-label="centered">
            <div style={{ width: "80px" }}>Satellite</div>
          </ToggleButton>
        </ToggleButtonGroup>
      </div> */}
    </div>
  )
}

export default Map
